import { FolderPlus } from 'lucide-react';
import { motion } from 'framer-motion';
import collectionsImage from '@/assets/empty-state-collections.jpg';

interface CollectionsEmptyStateProps {
  onCreateCollection: () => void;
}

export function CollectionsEmptyState({ onCreateCollection }: CollectionsEmptyStateProps) {
  return (
    <div className="relative w-full min-h-[70vh] rounded-2xl overflow-hidden mt-2">
      {/* Background image */}
      <img
        src={collectionsImage}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20" />
      
      {/* Content */}
      <div className="relative flex flex-col items-center justify-end h-full min-h-[70vh] px-6 pb-28">
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl font-bold text-white mb-2 drop-shadow-lg text-center"
        >
          Organize your saves
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="text-sm text-white/70 mb-6 drop-shadow text-center max-w-xs"
        >
          Group your saves into themed collections
        </motion.p>

        <motion.button
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 300, damping: 25 }}
          onClick={onCreateCollection}
          className="flex items-center gap-3 px-6 py-3 rounded-full bg-white text-black font-medium shadow-xl active:scale-95 transition-transform"
          whileTap={{ scale: 0.95 }}
        >
          <FolderPlus className="w-5 h-5" />
          <span>Create Collection</span>
        </motion.button>
      </div>
    </div>
  );
}
